import { useCallback, useContext } from 'react';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { ActiveSuggestedAction } from 'router/subrouters/DataRoom/models/Dashboard';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { useTranslation } from 'react-i18next';
import {
  ACTIONED_SUGGESTED_ACTION_ACTION,
  ACTIONED_SUGGESTED_ACTION_NAME,
} from '../data';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import { SUGGESTION_PAGE } from 'models/SuggestedActions';

export default function useActionedSuggestedAction() {
  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);

  const { t } = useTranslation();

  const getMixpanelProps = useGetMixpanelProps();

  return useCallback(
    async (suggestion: ActiveSuggestedAction) => {
      if (!dataRoomId || !suggestion) return;

      const { type, count = 1 } = suggestion || {};

      const suggestionNameKey = ACTIONED_SUGGESTED_ACTION_NAME[type];
      const suggestionActionKey = ACTIONED_SUGGESTED_ACTION_ACTION[type];

      try {
        await dataRoomApi.room.actionedSuggestedAction(dataRoomId, {
          suggestionName: t(suggestionNameKey, { count }),
          suggestionAction: t(suggestionActionKey, { count }),
          suggestionPage: SUGGESTION_PAGE.DATA_ROOM,
        });
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
      }
    },
    [dataRoomId, getMixpanelProps, t],
  );
}
